import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import { usePageSeo, SITE_ORIGIN } from "@/hooks/usePageSeo";
import { site, faqs } from "@/mocks/site";
import Hero from "./components/Hero";
import TrendingSection from "./components/TrendingSection";
import CategorySection from "./components/CategorySection";
import FeaturedSection from "./components/FeaturedSection";
import StepsSection from "./components/StepsSection";
import ChatPreview from "./components/ChatPreview";
import TestimonialsSection from "./components/TestimonialsSection";
import FaqSection from "./components/FaqSection";
import ContactSection from "./components/ContactSection";

const jsonLd = {
  "@context": "https://schema.org",
  "@graph": [
    {
      "@type": "Organization",
      name: site.name,
      url: SITE_ORIGIN,
      slogan: site.slogan,
      email: site.email,
      description: site.describe,
    },
    {
      "@type": "WebSite",
      name: site.name,
      url: SITE_ORIGIN,
      inLanguage: "zh-CN",
      description: site.tagline,
      potentialAction: {
        "@type": "SearchAction",
        target: `${SITE_ORIGIN}/hot?q={search_term_string}`,
        "query-input": "required name=search_term_string",
      },
    },
    {
      "@type": "FAQPage",
      mainEntity: faqs.map((item) => ({
        "@type": "Question",
        name: item.q,
        acceptedAnswer: { "@type": "Answer", text: item.a },
      })),
    },
  ],
};

export default function Home() {
  usePageSeo({
    title: "诱惑吃瓜 - 必看围观姿势 进聊天室蹲后续",
    description:
      "诱惑吃瓜聚集最会吃瓜的一群人：实时热瓜榜、完整时间线梳理、反转复盘与围观礼仪教程，进聊天室与群聊一起蹲后续，最新进展第一时间同步。",
    keywords: "诱惑吃瓜,吃瓜社区,娱乐热点,围观姿势,聊天室蹲后续,反转复盘,热瓜榜",
    path: "/",
    jsonLd,
  });

  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />
      <main>
        <Hero />
        <TrendingSection />
        <CategorySection />
        <FeaturedSection />
        <StepsSection />
        <ChatPreview />
        <TestimonialsSection />
        <FaqSection />
        <ContactSection />
      </main>
      <Footer />
    </div>
  );
}